import { Button, Table, Input, Row, Col, Modal, Radio, message, Typography, Select, Card, Tag, Space} from "antd";
import { useEffect, useRef, useState, } from "react";
import Highlighter from 'react-highlight-words';
import api from "../../API";
import { DeleteOutlined, SearchOutlined, SyncOutlined } from "@ant-design/icons";

function Contacts() {
  const user = JSON.parse(localStorage.getItem('user'));
  const [loading, setLoading] = useState({table: false, btn: false});
  const [dataSource, setDataSource] = useState([]);
  const [searchText, setSearchText] = useState('');
  const [options, setOptions] = useState(null);
  const [filterByBtn, setFilterByBtn] = useState('All');
  const [selectedOAIndex, setselectedOAIndex] = useState(null);
  const originalContacts = useRef([]);
  const originalOAAccounts = useRef([]);
  const [tagColors, setTagColors] = useState(new Map());
  
  const TAG_COLORS = ['magenta', 'red', 'volcano', 'orange', 'gold', 'lime', 'green', 'cyan', 'blue', 'geekblue', 'purple'];

  const columns = [
    {
      title: "Name",
      dataIndex: "display_name",
      width: 150,
      render: (text) =>
        searchText ? (
          <Highlighter
            highlightStyle={{
              backgroundColor: '#ffc069',
              padding: 0,
            }}
            searchWords={[searchText]}
            autoEscape
            textToHighlight={text ? text.toString() : ''}
          />
        ) : (
          text
        )
    },
    {
      title: "UID",
      dataIndex: "zaloUid",
      render: (text) =>
        searchText ? (
          <Highlighter
            highlightStyle={{
              backgroundColor: '#ffc069',
              padding: 0,
            }}
            searchWords={[searchText]}
            autoEscape
            textToHighlight={text ? text.toString() : ''}
          />
        ) : (
          text
        )
    },
    {
      title: "OA Account",
      dataIndex: "accountName",
      render: (text) =>
        searchText ? (
          <Highlighter
            highlightStyle={{
              backgroundColor: '#ffc069',
              padding: 0,
            }}
            searchWords={[searchText]}
            autoEscape
            textToHighlight={text ? text.toString() : ''}
          />
        ) : (
          text
        )
    },
    {
      title: "Phone",
      dataIndex: "phone",
      render: (text) =>
        searchText ? (
          <Highlighter
            highlightStyle={{
              backgroundColor: '#ffc069',
              padding: 0,
            }}
            searchWords={[searchText]}
            autoEscape
            textToHighlight={text ? text.toString() : ''}
          />
        ) : (
          text
        )
    },
    {
      title: "Address",
      dataIndex: "address",
      render: (text) =>
        searchText ? (
          <Highlighter
            highlightStyle={{
              backgroundColor: '#ffc069',
              padding: 0,
            }}
            searchWords={[searchText]}
            autoEscape
            textToHighlight={text ? text.toString() : ''}
          />
        ) : (
          text
        )
    },
    {
      title: "Ward",
      dataIndex: "ward",
      render: (text) =>
        searchText ? (
          <Highlighter
            highlightStyle={{
              backgroundColor: '#ffc069',
              padding: 0,
            }}
            searchWords={[searchText]}
            autoEscape
            textToHighlight={text ? text.toString() : ''}
          />
        ) : (
          text
        )
    },
    {
      title: "District",
      dataIndex: "district",
      render: (text) =>
        searchText ? (
          <Highlighter
            highlightStyle={{
              backgroundColor: '#ffc069',
              padding: 0,
            }}
            searchWords={[searchText]}
            autoEscape
            textToHighlight={text ? text.toString() : ''}
          />
        ) : (
          text
        )
    },
    {
      title: "City",
      dataIndex: "city",
      render: (text) =>
        searchText ? (
          <Highlighter
            highlightStyle={{
              backgroundColor: '#ffc069',
              padding: 0,
            }}
            searchWords={[searchText]}
            autoEscape
            textToHighlight={text ? text.toString() : ''}
          />
        ) : (
          text
        )
    },
    {
      title: "Tags",
      dataIndex: "tags",
      render: (arr) => {
        if (!arr?.length) return '';
        
        return (
          <Space wrap size={0.5}>
            {arr.map((tag, i) => {
              if (!tag) return null;
              
              if (searchText && tag.toLowerCase().includes(searchText.toLowerCase())) {
                return (
                  <Tag color={tagColors.get(tag)} key={i}>
                    <Highlighter
                      highlightStyle={{
                        backgroundColor: '#ffc069',
                        padding: 0,
                      }}
                      searchWords={[searchText]}
                      autoEscape
                      textToHighlight={tag}
                    />
                  </Tag>
                );
              }
              
              return <Tag color={tagColors.get(tag)} key={i}>{tag}</Tag>;
            })}
          </Space>
        );
      }
    },
    {
      title: 'Action',
      key: 'action',
      width: 100,
      align: 'center',
      render: (_, record) => (
        <Button type="primary" danger 
                icon={<DeleteOutlined/>}
                onClick={() => {
                  Modal.confirm({
                    title: 'Confirm deletion',
                    content: 'Are you sure you want to delete this contact?',
                    onOk() {handleRemoveRow(record.key)},
                    maskClosable: true
                  })
                }}>
        </Button>),
    }
  ];

  useEffect(() => {
    setLoading({...loading, table: true});
    Promise.all([
      api.list_oaaccounts_by_user(user?.userId, user?.parentId,["id","accountName" , "OAId"]),
      api.list_all_contacts(user?.userId)])
    .then(([oaacounts, contacts]) => {
      const uniqueTags = new Set();
      contacts.forEach(contact => {
        const tags = contact.tags?.split(',') || [];
        tags.forEach(tag => tag && uniqueTags.add(tag));
      });

      const tagColorMap = new Map();
      Array.from(uniqueTags).forEach((tag, index) => {
        tagColorMap.set(tag, TAG_COLORS[index % TAG_COLORS.length]);
      });
      setTagColors(tagColorMap);

      originalContacts.current = contacts.length? contacts.map(contact => ({
        OAId: contact.OAId, 
        key: contact.id, 
        display_name: contact.display_name,
        zaloUid: contact.zaloUid,
        phone: contact.phone,
        accountName: oaacounts.find(oaacount => oaacount.OAId === contact.OAId)?.accountName,
        address: contact.address,
        ward: contact.ward,
        district: contact.district,
        tags: contact.tags?.split(',').filter(Boolean),
        city: contact.city
      })) : [];
      originalOAAccounts.current = oaacounts;
      setOptions(oaacounts.map((oaacount, i) => ({
        value: i,
        label: oaacount.accountName
      })))
      setDataSource(originalContacts.current); 
    })
    .catch(err => message.error(err.message))
    setLoading({...loading, table: false});
  }, []);

  function handleFilterDataByRadioBtn(e) {
    let newContacts = originalContacts.current;
    if(e.target.value !== 'All' && e.target.value !== 'Follower') newContacts = newContacts.filter((value) => value[e.target.value]);
    if(selectedOAIndex || selectedOAIndex === 0) newContacts = newContacts.filter(value => value.OAId === originalOAAccounts.current[selectedOAIndex].OAId);
    if(searchText) newContacts = newContacts.filter((o) => Object.keys(o).slice(2).some((k) => o[k] && String(o[k])
      .toLowerCase()
      .includes(searchText.toLowerCase())));
    setLoading(true);
    setFilterByBtn(e.target.value);
    setDataSource(newContacts);
    setLoading(false);
  }

  function handleselectedOAIndex(OAIndex) {
    let newContacts = originalContacts.current;
    if(filterByBtn !== 'All' && filterByBtn !== 'Follower') newContacts = newContacts.filter((value) => value[filterByBtn]);
    if(OAIndex || OAIndex === 0) newContacts = newContacts.filter(value => value.OAId === originalOAAccounts.current[OAIndex].OAId);
    if(searchText) newContacts = newContacts.filter((o) => Object.keys(o).slice(2).some((k) => o[k] && String(o[k])
      .toLowerCase()
      .includes(searchText.toLowerCase())));
    setLoading(true);
    setselectedOAIndex(OAIndex);
    setDataSource(newContacts);
    setLoading(false);
  }

  function handleSearchInfo(e) {
    let newContacts = originalContacts.current;
    if(filterByBtn !== 'All' && filterByBtn !== 'Follower') newContacts = newContacts.filter((value) => value[filterByBtn]);
    if(selectedOAIndex || selectedOAIndex === 0) newContacts = newContacts.filter(value => value.OAId === originalOAAccounts.current[selectedOAIndex].OAId);
    if(e.target.value) newContacts = newContacts.filter((o) => Object.keys(o).slice(2).some((k) => o[k] && String(o[k])
      .toLowerCase()
      .includes(e.target.value.toLowerCase())));
    setLoading(true);
    setSearchText(e.target.value);
    setDataSource(newContacts);
    setLoading(false);
  }

  async function handleUpdateContacts() {
    try {
      setLoading({btn: true, table: true});
      const response = await api.list_all_contacts_on_zalo(user?.userId, user?.parentId, originalOAAccounts.current[selectedOAIndex]?.OAId);
      if(response) {
        const dataContact = await api.list_all_contacts(user?.userId); 
        const uniqueTags = new Set();
        dataContact.forEach(contact => {
          const tags = contact.tags?.split(',') || [];
          tags.forEach(tag => tag && uniqueTags.add(tag));
        });
  
        const tagColorMap = new Map();
        Array.from(uniqueTags).forEach((tag, index) => {
          tagColorMap.set(tag, TAG_COLORS[index % TAG_COLORS.length]);
        });
        setTagColors(tagColorMap);
        let contacts = dataContact.map(contact=>{
          const oaacountObj = originalOAAccounts.current.find(oaacount => oaacount.id === contact.accountId);
          return ({ 
            OAId: oaacountObj?.OAId,
            key: contact.id, 
            display_name: contact.display_name,
            zaloUid: contact.zaloUid,
            accountName: oaacountObj?.accountName,
            phone: contact.phone,
            tags: contact.tags?.split(',').filter(Boolean),
            address: contact.address,
            ward: contact.ward,
            district: contact.district,
            city: contact.city
          })});
        originalContacts.current = contacts.concat();
        if(selectedOAIndex  || selectedOAIndex === 0) contacts = contacts.filter(value => value.OAId === originalOAAccounts.current[selectedOAIndex].OAId);
        setDataSource(contacts);
      }
    } catch (error) {
      message.error(error.message)
    }
    setLoading({btn: false, table: false});
  }

  async function handleRemoveRow(keyRemove) {
    try {
      setLoading({...loading, table: true});
      const responseRemove = await api.delete_contact_byID(keyRemove);
      originalContacts.current = originalContacts.current.filter((value) => value.key !== keyRemove);
      let contacts = originalContacts.current.concat();
      if(selectedOAIndex  || selectedOAIndex === 0) contacts = contacts.filter(value => value.OAId === originalOAAccounts.current[selectedOAIndex].OAId);
      setDataSource(contacts);
      message.success(responseRemove.message);
    } catch (error) {
      message.error(error.message)
    } 
    setLoading({...loading, table: false});
  }

  return (
    <Card 
      style={{height: '100%', margin: "0 auto", boxShadow: "1px 1px 5px #ccc", borderRadius: 10 }}
      title={
        <Typography.Title level={5} style={{margin: 0}}>Manage your OA audiences</Typography.Title>
      }
      loading={loading.table}
      extra={<Button type="primary" style={{padding:15}} loading={loading.btn} onClick={handleUpdateContacts} icon={<SyncOutlined />}>Update Contacts</Button>}
    >
      <Row gutter={[16,16]}  align="middle">
        <Col xxl={8} xl={8} lg={24} md={24} sm={24} xs={24}>
          <Radio.Group defaultValue='All' onChange={handleFilterDataByRadioBtn}> 
            <Radio.Button value='All' >All</Radio.Button>
            <Radio.Button value='Follower' >Follower</Radio.Button>
            <Radio.Button value='phone' >Shared Info</Radio.Button>
            {/* <Radio.Button value={3}>Active</Radio.Button> */}
          </Radio.Group>
        </Col>
        <Col xxl={8} xl={8} lg={12} md={12} sm={24} xs={24}>
          <Select 
            style={{width:'100%'}}
            placeholder="Select OA Id"
            popupMatchSelectWidth={false}
            value={selectedOAIndex}
            allowClear
            showSearch
            filterOption={(input, option) =>
              (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
            }
            onChange={handleselectedOAIndex}
            options={options}
          />
        </Col>
        <Col xxl={8} xl={8} lg={12} md={12} sm={24} xs={24}>
          <Input 
              placeholder="Input search text"
              allowClear
              onChange={handleSearchInfo}
              suffix={<SearchOutlined />}/>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <Table  
            bordered
            scroll={{x: 1000}}
            columns= {columns} 
            style={{marginTop: 16, width: '100%'}} 
            dataSource={dataSource}
            loading={loading.table}
            pagination={{
              position: ["bottomCenter"],
              showSizeChanger: false, 
              pageSize: 10, 
              showTotal: () => `Total: ${dataSource.length} items`
            }}/>
        </Col>
      </Row>
    </Card>
  )
}

export default Contacts;
